import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { trackAddToCart } from '../../utils/pixel';
export function StickyBuyBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const finalCta = document.getElementById('final-cta');
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      // Show after scrolling past hero
      const pastHero = scrollY > 600;
      // Hide when FinalCTA section is in view
      let finalCtaInView = false;
      if (finalCta) {
        const rect = finalCta.getBoundingClientRect();
        finalCtaInView = rect.top < windowHeight && rect.bottom > 0;
      }
      setIsVisible(pastHero && !finalCtaInView);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-189">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} onClick={() => {
      trackAddToCart();
      window.open('https://financialsledge.com/cart/53082740883770:1', '_blank');
    }} className="fixed bottom-0 left-0 w-full bg-dark-100/95 backdrop-blur-md border-t border-gold/20 p-4 z-50 shadow-2xl cursor-pointer hover:bg-dark-200/95 transition-colors" data-id="element-190">
          <div className="max-w-6xl mx-auto flex items-center justify-between" data-id="element-191">
            <div data-id="element-192">
              <p className="text-white font-heading font-bold text-lg" data-id="element-193">
                The Credit Repair Sledgehammer
              </p>
              <div className="flex items-center gap-2" data-id="element-194">
                <span className="line-through text-gray-500 text-sm" data-id="element-195">$27</span>
                <span className="text-gold text-sm font-bold" data-id="element-196">
                  $6.39 — Launch Special
                </span>
              </div>
            </div>
            <div className="flex items-center gap-2 text-gold font-bold text-sm uppercase tracking-wider" data-id="element-197">
              Get It Now <ArrowRight className="w-4 h-4" data-id="element-198" />
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}